export default __webpack_public_path__ + "static/ovako_logo.inline-4d1d4970dd69a6bf670c075e785d7783.png";